import user from './user';
import asset from './asset';
import stock from './stock';
import info from './info';
import openAccount from './openAccount';

const language = {
    ...user,
    ...asset,
    ...stock,
    ...info,
    ...openAccount
};

export default language;